import React from 'react';
import { Radio } from 'antd';

const { Button, Group } = Radio;

const OrderTypes = ({
  onChangeTypeList,
  totalOrders,
  typesList,
  stat,
  value,
}) => {
  return (
    <Group onChange={onChangeTypeList} defaultValue={value ? value : 'all'}>
      <Button value="all">Все: {totalOrders}</Button>
      {typesList &&
        typesList.map(item => {
          let count = stat && stat[item.key] ? stat[item.key] : 0;
          return (
            <Button key={item.key} value={item.key} disabled={!count}>
              {item.status}: {count}
            </Button>
          );
        })}
    </Group>
  );
};

export default OrderTypes;
